<template>
  <div class="container">
   
    <div class="evol encart">
      <h2>Nouvelle évolution d'affaire</h2>
      
      <!-- Options de création (d'abord) -->
      <div class="fichiers">
        <label>Choisir le mode de création :</label>
        <div class="radio-group">
          <label class="radio-option">
            <input type="radio" v-model="modeCreation" value="copier" @change="onModeCreationChange"> Copier le contenu d'une affaire
          </label>
          <label class="radio-option">
            <input type="radio" v-model="modeCreation" value="zero" @change="onModeCreationChange"> Repartir de zéro
          </label>
        </div>
      </div>

      <!-- Sélection d'affaire (après le choix du mode) -->
      <div class="fichiers" v-if="modeCreation === 'copier'">
        <label>Sélectionner une affaire à copier :</label>
        <select v-model="selectedAffaire" @change="onAffaireChange" class="affaire-select">
          <option value="">-- Sélectionner une affaire --</option>
          <option v-for="affaire in affaires" :key="affaire.naf" :value="affaire">
            {{ affaire.naf }} - {{ affaire.desa }} ({{ affaire.client }})
          </option>
        </select>
      </div>

      <!-- Description pour nouvelle affaire -->
      <div class="fichiers" v-if="modeCreation === 'zero' || modeCreation === 'copier'">
        <label>Nouvelle description :</label>
        <input type="text" v-model="nouvelleDescription" placeholder="Nouvelle description de l'affaire...">
      </div>

      <!-- Section unique pour tous les articles -->
      <div class="fichiers" v-if="(modeCreation === 'copier' && selectedAffaire) || (modeCreation === 'zero' && nouvelleDescription)">
        <h3>Articles de l'évolution</h3>
        
        <!-- Sélection d'article depuis la liste -->
        <div class="ajout-article">
          <div class="form-row">
            <div class="form-group search-article">
              <label>Rechercher et sélectionner un article :</label>
              <div class="search-container">
                <input 
                  type="text" 
                  v-model="searchArticle" 
                  @input="rechercherArticles"
                  placeholder="Rechercher un article par code ou désignation..."
                  class="search-input">
                <div v-if="articlesDisponibles.length > 0 && searchArticle" class="articles-dropdown">
                  <div 
                    v-for="article in articlesDisponibles" 
                    :key="article.coarti"
                    @click="selectionnerArticle(article)"
                    class="article-option">
                    <div class="article-code">{{ article.coarti }}</div>
                    <div class="article-designations">
                      <span v-if="article.desa1">{{ article.desa1 }}</span>
                      <span v-if="article.desa2"> - {{ article.desa2 }}</span>
                      <span v-if="article.desa3"> - {{ article.desa3 }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        
          
          <!-- Détails de l'article sélectionné -->
          <div v-if="articleSelectionne" class="article-selectionne">
            <h4>Article sélectionné :</h4>
            <div class="article-details">
              <div class="form-row">
                <div class="form-group">
                  <label>Code article :</label>
                  <input type="text" :value="articleSelectionne.coarti" readonly class="readonly-input">
                </div>
                <div class="form-group">
                  <label>Désignation 1 :</label>
                  <input type="text" :value="articleSelectionne.desa1" readonly class="readonly-input">
                </div>
                <div class="form-group">
                  <label>Désignation 2 :</label>
                  <input type="text" :value="articleSelectionne.desa2" readonly class="readonly-input">
                </div>
              </div>
              <div class="form-row">
                <div class="form-group">
                  <label>Désignation 3 :</label>
                  <input type="text" :value="articleSelectionne.desa3" readonly class="readonly-input">
                </div>
                <div class="form-group">
                  <label>Quantité :</label>
                  <input type="number" v-model="quantiteArticle" placeholder="Quantité" min="1">
                </div>
              </div>
            </div>
            <button type="button" @click="ajouterArticleSelectionne" class="btn-add">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-plus-circle" viewBox="0 0 16 16">
                <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
              </svg>
              Ajouter l'article
            </button>
            <button type="button" @click="annulerSelection" class="btn-cancel">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-circle" viewBox="0 0 16 16">
                <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
              </svg>
              Annuler
            </button>
          </div>


          <!-- Ajout manuel -->
        <div class="nouvel-article-form">
          <h4>Ajouter un article qui n'apparaît pas dans la liste</h4>
          <div class="form-row">
            <div class="form-group">
              <label>Code article :</label>
              <input
                type="text"
                v-model="nouveauArticleCode"
                placeholder="Ex : ABC123"
              >
            </div>
            <div class="form-group">
              <label>Désignation :</label>
              <input
                type="text"
                v-model="nouveauArticleDesignation"
                placeholder="Description"
              >
            </div>
            <div class="form-group">
              <label>Quantité :</label>
              <input
                type="number"
                min="1"
                v-model="nouveauArticleQuantite"
                placeholder="Quantité"
              >
            </div>
          </div>
          <button type="button" class="btn-add" @click="ajouterArticleManuel">
            Ajouter cet article
          </button>
        </div>
        </div>

        <!-- Tableau unique des articles -->
        <div v-if="tousLesArticles.length > 0" class="articles-container">
          <table class="articlesListe">
            <thead>
              <tr>
                <th>Type</th>
                <th>Code article</th>
                <th>Désignations</th>
                <th>Quantité</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(article, index) in tousLesArticles" :key="'article-' + index" :class="index % 2 === 0 ? 'ligne-claire' : 'ligne-foncee'">
                <td>
                  <span v-if="article.type === 'ajoute'" class="badge badge-success">Ajouté</span>
                  <span v-else-if="article.estModifie" class="badge badge-modifie">Modifié</span>
                  <span v-else class="badge badge-primary">Existant</span>
                </td>
                <td>{{ article.code }}</td>
                <td style="text-align: left;">
                  <span v-if="article.designation1">{{ article.designation1 }}</span><br v-if="article.designation1">
                  <span v-if="article.designation2">{{ article.designation2 }}</span><br v-if="article.designation2">
                  <span v-if="article.designation3">{{ article.designation3 }}</span>
                </td>
                <td>
                <input
                  v-if="article.type === 'existant' && articlesModifications[article.code]"
                  type="number"
                  v-model="articlesModifications[article.code].nouvelleQuantite"
                  :placeholder="article.quantiteOriginale"
                  class="qte-input"
                />
                <span v-else>{{ article.quantite }}</span>
              </td>

                <td>
                  <button type="button" @click="supprimerArticle(index, article.type)" class="btn-delete">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-trash" viewBox="0 0 16 16">
                      <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"/>
                      <path fill-rule="evenodd" d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"/>
                    </svg>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Tableau des articles modifiés -->
        <div class="fichiers" v-if="articlesModifies.length > 0">
          <h3>Articles existants modifiés</h3>
          <div class="articles-container">
            <table class="articlesListe">
              <thead>
                <tr>
                  <th>Code article</th>
                  <th>Quantité originale</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(article, index) in articlesModifies" :key="'modif-' + index" :class="index % 2 === 0 ? 'ligne-claire' : 'ligne-foncee'">
                  <td>{{ article.code }}</td>
                  <td>{{ article.quantiteOriginale }}</td>
                  <td><strong>{{ article.nouvelleQuantite }}</strong></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <!-- Destinataires -->
      <div class="fichiers" v-if="(modeCreation === 'copier' && selectedAffaire) || (modeCreation === 'zero' && nouvelleDescription)">
        <label>Envoyer la demande à :</label>
        <div class="checkbox-group">
          <label class="checkbox-option" v-for="email in destinatairesEmails" :key="email">
            <input type="checkbox" v-model="destinataires" :value="email"> {{ email }}
          </label>
        </div>
      </div>

      <!-- Observations & Photos -->
      <div class="fichiers" v-if="(modeCreation === 'copier' && selectedAffaire) || (modeCreation === 'zero' && nouvelleDescription)">
        <div class="form-group">
          <label for="observations">Observations</label>
          <textarea
            id="observations"
            v-model="evolution.observations"
            rows="4"
            placeholder="Ajoutez vos remarques ou précisions complémentaires"
          ></textarea>
        </div>
        <div class="form-group">
          <label for="photos">Photos</label>
          <input
            id="photos"
            ref="photosInput"
            type="file"
            multiple
            accept="image/*"
            class="file-input"
            @change="handlePhotosChange"
          />
          <p class="input-hint">Formats acceptés : JPG, PNG, WebP. Taille max recommandée : 5 Mo par fichier.</p>
          <ul v-if="photosSelectionnees.length" class="photos-list">
            <li v-for="(photo, index) in photosSelectionnees" :key="photo.name + index" class="photo-item">
              <div class="photo-infos">
                <strong>{{ photo.name }}</strong>
                <small>{{ (photo.size / 1024).toFixed(1) }} Ko</small>
              </div>
              <button type="button" class="btn-link" @click="supprimerPhoto(index)">
                Retirer
              </button>
            </li>
          </ul>
        </div>
      </div>

      <!-- Actions -->
      <div class="fichiers actions" v-if="(modeCreation === 'copier' && selectedAffaire) || (modeCreation === 'zero' && nouvelleDescription)">
        <button type="button" @click="sauvegarder" class="btn-secondary">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-save" viewBox="0 0 16 16">
            <path d="M2 1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H9.5a1 1 0 0 0-1 1v7.293l2.646-2.647a.5.5 0 0 1 .708.708l-3.5 3.5a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L7.5 9.293V2a2 2 0 0 1 2-2H14a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h2.5a.5.5 0 0 1 0 1H2z"/>
          </svg>
          Sauvegarder brouillon
        </button>
        <button type="button" @click="envoyerDemande" class="btn-primary">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-send" viewBox="0 0 16 16">
            <path d="M15.854.146a.5.5 0 0 1 .11.54L13.026 8.03l2.938 7.344a.5.5 0 0 1-.538.688l-14-4a.5.5 0 0 1-.063-.94L15.146.037a.5.5 0 0 1 .708.109z"/>
          </svg>
          Envoyer la demande
        </button>
      </div>

      <!-- Messages -->
      <div v-if="confirmationMessage" class="alert alert-success">
        {{ confirmationMessage }}
      </div>
      <div v-if="errorMessage" class="alert alert-error">
        {{ errorMessage }}
      </div>
    </div>
  </div>
</template>

<script>
import axios from '@/components/axiosConfig.js'
import VueCookies from 'vue-cookies'

export default {
  data() {
    return {
      isBrouillon: false,
      affaires: [],
      selectedAffaire: null,
      nouvelleDescription: '',
      modeCreation: 'copier',
      destinataires: [],
      articles: [],
      articlesSupprimes: [],
      articleDetails: {},
      articlesModifications: {},
      articlesAjoutes: [],
      searchArticle: '',
      articlesDisponibles: [],
      destinatairesEmails: [],
      articleSelectionne: null,
      quantiteArticle: '',
      nouveauArticleCode: '',
      nouveauArticleDesignation: '',
      nouveauArticleQuantite: '',
      searchTimeout: null,
      evolution: {
        piece: '',
        designation: '',
        client: '',
        quantite: '',
        delai: '',
        observations: ''
      },
      utilisateur: '',
      loggedInEmail: '',
      confirmationMessage: '',
      errorMessage: '',
      photosSelectionnees: [],
    }
  },
  computed: {
    tousLesArticles() {
      const normaliserCode = code => String(code || '').trim();

      const articlesExistants = this.articles
        .filter(article => !this.articlesSupprimes.includes(normaliserCode(article.npce || article.coarti)))
        .map(article => {
          const code = normaliserCode(article.npce || article.coarti);
          const modif = this.articlesModifications[code];
          const quantiteOriginale = parseFloat(article.qte) || 0;
          const valeurModifiee = modif?.nouvelleQuantite;
          const valeurModifieeNombre = typeof valeurModifiee !== 'undefined' ? parseFloat(valeurModifiee) : NaN;
          const estModifie =
            !!(modif &&
            valeurModifiee !== '' &&
            !Number.isNaN(valeurModifieeNombre) &&
            valeurModifieeNombre !== quantiteOriginale);

          return {
            type: 'existant',
            estModifie,
            code,
            designation1: article.desa1,
            designation2: article.desa2,
            designation3: article.desa3,
            quantiteOriginale: quantiteOriginale
          };
        });

      const articlesAjoutesFormates = this.articlesAjoutes.map(article => ({
        type: 'ajoute',
        estModifie: false,
        code: normaliserCode(article.code),
        designation1: article.designation1 || '',
        designation2: article.designation2 || '',
        designation3: article.designation3 || '',
        quantite: article.quantite
      }));

      return [...articlesExistants, ...articlesAjoutesFormates];
    },
    
    articlesFusionnes() {
      const fusion = [];
      const modifs = this.articlesModifications;
      const codesSupprimes = this.articlesSupprimes;
      const codesExistants = this.articles.map(a => String(a.npce || a.coarti || '').trim());

      this.articles.forEach(article => {
        const code = String(article.npce || article.coarti || '').trim();
        const quantiteOrig = parseFloat(article.qte) || 0;
        const modif = modifs[code];

        if (codesSupprimes.includes(code)) {
          fusion.push({
            code,
            quantiteActuelle: 0,
            quantitePrecedente: quantiteOrig,
            statut: 'supprimé'
          });
        }
        else if (modif && modif.nouvelleQuantite !== '' && !isNaN(modif.nouvelleQuantite)) {
          const quantiteNouvelle = parseFloat(modif.nouvelleQuantite);
          fusion.push({
            code,
            quantiteActuelle: quantiteNouvelle,
            quantitePrecedente: quantiteOrig,
            statut: quantiteNouvelle !== quantiteOrig ? 'modifié' : 'ignoré'
          });
        } else {
          fusion.push({
            code,
            quantiteActuelle: quantiteOrig,
            quantitePrecedente: quantiteOrig,
            statut: 'ignoré'
          });
        }
      });

      this.articlesAjoutes.forEach(article => {
        const code = String(article.code).trim();
        if (!codesExistants.includes(code)) {
          fusion.push({
            code,
            quantiteActuelle: parseFloat(article.quantite) || 0,
            quantitePrecedente: 0,
            statut: 'ajouté'
          });
        }
      });

      console.log('🧾 Articles fusionnés envoyés :', fusion);
      return fusion;
    },

    // Nouveau computed pour les codes d'articles ajoutés seulement
    articlesAjoutesCodes() {
      return this.articlesAjoutes.map(article => ({
        code: article.code,
        quantite: article.quantite
      }));
    },

    // Nouveau computed pour les articles modifiés seulement
    articlesModifies() {
      const resultats = [];
      
      // Parcourir les modifications d'articles
      Object.keys(this.articlesModifications).forEach(codeArticle => {
        const modif = this.articlesModifications[codeArticle];
        
        // Vérifier si l'article n'est pas supprimé et si la quantité a été modifiée
        if (!this.articlesSupprimes.includes(codeArticle) && modif.nouvelleQuantite !== '') {
          const articleExistant = this.articles.find(art => art.npce === codeArticle);
          if (articleExistant) {
            const quantiteOriginale = parseInt(articleExistant.qte) || 0;
            const nouvelleQuantite = parseInt(modif.nouvelleQuantite) || 0;
            
            // Inclure seulement si la quantité a vraiment changé
            if (quantiteOriginale !== nouvelleQuantite) {
              resultats.push({
                code: codeArticle,
                quantiteOriginale: quantiteOriginale,
                nouvelleQuantite: nouvelleQuantite
              });
            }
          }
        }
      });
      
      return resultats;
    }
  },
  created() {
  },
  mounted() { 
    this.chargerAffaires();

    const nom = VueCookies.get('nom')
    if (nom) {
        this.utilisateur = nom
    }
    const prenom = VueCookies.get('prenom')
    if (prenom) {
      this.utilisateur += " " + prenom;
    }

    const email = VueCookies.get('email')
    if (email) {
      this.loggedInEmail = email
    }

    

    axios.post('https://www.simef.fr/espace-client/api/getInternUtilisateurs.php')
    .then(response => {
      this.destinatairesEmails = response.data;
    })
    .catch(error => {
      console.error('Erreur lors de la récupération des emails internes:', error);
    });
  }, 
  methods: {
    chargerAffaires() {
      const loggedInRole = VueCookies.get('role');
      const loggedInEmail = VueCookies.get('email');
      
      let loggedEmail = "";
      if (loggedInRole == "admin" || loggedInRole == "gestion" || loggedInRole == "be" || loggedInRole == "achats") {
        loggedEmail = "";
      } else {
        loggedEmail = loggedInEmail;
      }

      axios.post('https://www.simef.fr/espace-client/api/getAffaires.php', {
        page: -1,
        loggedInEmail: loggedEmail,
      })
      .then(response => {
        this.affaires = response.data.affaires;
      })
      .catch(error => {
        console.error(error);
        this.errorMessage = "Erreur lors du chargement des affaires";
      });
    },

    onAffaireChange() {
      if (this.selectedAffaire) {
        // Charger les articles seulement si mode copier
        if (this.modeCreation === 'copier') {
          this.chargerArticlesAffaire();
        } else {
          // Réinitialiser les articles pour le mode zéro
          this.articles = [];
          this.articlesSupprimes = [];
          this.articleDetails = {};
          this.articlesModifications = {};
        }
        
        if (this.modeCreation === 'copier') {
          // Copier les données de l'affaire sélectionnée
          this.evolution.piece = this.selectedAffaire.piece || '';
          this.evolution.designation = this.selectedAffaire.desa || '';
          this.evolution.client = this.selectedAffaire.client || '';
          this.evolution.quantite = this.selectedAffaire.qte || '';
          this.evolution.delai = '';
          this.evolution.observations = '';
          this.evolution.photos = '';
        } else if (this.modeCreation === 'zero') {
          // Remettre à zéro
          this.resetEvolution();
        }
      } else {
        // Réinitialiser les articles si aucune affaire n'est sélectionnée
        this.articles = [];
        this.articlesSupprimes = [];
        this.articleDetails = {};
        this.articlesModifications = {};
      }
    },

    onModeCreationChange() {
      if (this.selectedAffaire) {
        if (this.modeCreation === 'copier') {
          // Charger les articles de l'affaire
          this.chargerArticlesAffaire();
          this.nouvelleDescription = '';
        } else {
          // Vider la liste des articles existants
          this.articles = [];
          this.articlesSupprimes = [];
          this.articleDetails = {};
          this.articlesModifications = {};
          this.selectedAffaire = null;
        }
      }
      if (this.modeCreation === 'zero') {
        this.selectedAffaire = null;
        this.articles = [];
        this.articlesSupprimes = [];
        this.articleDetails = {};
        this.articlesModifications = {};
        this.articlesAjoutes = [];
        this.searchArticle = '';
        this.articlesDisponibles = [];
        this.articleSelectionne = null;
        this.quantiteArticle = '';
        this.resetNouvelArticle();
      }
      if (this.modeCreation === 'copier') {
        this.nouvelleDescription = '';
      }
    },

    chargerArticlesAffaire() {
      if (!this.selectedAffaire || !this.selectedAffaire.naf) return Promise.resolve();

      return axios.post('https://www.simef.fr/espace-client/api/getArticlesAffaire.php', {
        naf: this.selectedAffaire.naf,
        sortColumn: '',
        sortDirection: 'asc',
      })
      .then(response => {
        this.articles = response.data;

        // ⚠️ Ne réinitialise pas les articles si on recharge un brouillon
        if (!this.isLoadingBrouillon && !this.isBrouillon) {
          this.articlesSupprimes = [];
          this.articlesModifications = {};
          this.articles.forEach(article => {
            const code = String(article.npce || article.coarti || '').trim();
            this.articlesModifications[code] = {
              // ✅ On préremplit la quantité d’origine ici
              nouvelleQuantite: parseFloat(article.qte) || 0
            };
          });
        }
      })
      .catch(error => {
        console.error('Erreur lors de la récupération des articles:', error);
        this.errorMessage = "Erreur lors du chargement des articles de l'affaire";
      });
    },

    appliquerArticlesDepuisBrouillon(articles) {
      
      this.articlesAjoutes = [];
      this.articlesSupprimes = [];
      this.articlesModifications = {};

      articles.forEach(a => {
        const code = String(a.coarti || a.npce || '').trim();
        const qteActuelle = parseFloat(a.qte_actuelle ?? a.qte) || 0;

        if (a.statut === 'ajouté') {
          this.articlesAjoutes.push({
            code,
            quantite: qteActuelle
          });
        } else if (a.statut === 'supprimé') {
          this.articlesSupprimes.push(code);
        } else if (a.statut === 'modifié' || a.statut === 'ignoré') {
          this.articlesModifications[code] = {
            nouvelleQuantite: qteActuelle
          };
        }
      });

      console.log('✅ Résumé après application :', {
        articlesAjoutes: this.articlesAjoutes,
        articlesSupprimes: this.articlesSupprimes,
        articlesModifications: this.articlesModifications
      });
    },


    calculateSum(npce) {
      const details = this.articleDetails[npce];
      if (details) {
        return details.reduce((sum, detail) => sum + Number(detail.qte), 0);
      }
      return 0;
    },

    rechercherArticles() {
      // Annuler le timeout précédent
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }
      
      // Si la recherche est vide, vider les résultats
      if (!this.searchArticle || this.searchArticle.length < 2) {
        this.articlesDisponibles = [];
        return;
      }
      
      // Créer un nouveau timeout
      this.searchTimeout = setTimeout(() => {
        this.effectuerRechercheArticles();
      }, 300); // 300ms de délai
    },

    effectuerRechercheArticles() {
      const loggedInRole = VueCookies.get('role');
      const loggedInEmail = VueCookies.get('email');
      
      let loggedEmail = "";
      if (loggedInRole == "admin" || loggedInRole == 'gestion' || loggedInRole == 'be' || loggedInRole == 'achats') {
        loggedEmail = "";
      } else {
        loggedEmail = loggedInEmail;
      }

      axios.post('https://www.simef.fr/espace-client/api/getArticles.php', {
        page: 1,
        searchTerm: this.searchArticle,
        selectedMag: '',
        selectedFourn: '',
        loggedInEmail: loggedEmail,
        showOnlyAvailable: '',
        sortColumn: '',
        sortDirection: '',
      })
      .then(response => {
        this.articlesDisponibles = response.data.articles || [];
      })
      .catch(error => {
        console.error('Erreur lors de la recherche d\'articles:', error);
        this.articlesDisponibles = [];
      });
    },

    selectionnerArticle(article) {
      this.articleSelectionne = article;
      this.searchArticle = article.coarti + ' - ' + article.desa1;
      this.articlesDisponibles = [];
      this.quantiteArticle = '';
    },

    annulerSelection() {
      this.articleSelectionne = null;
      this.searchArticle = '';
      this.quantiteArticle = '';
      this.articlesDisponibles = [];
    },

    ajouterArticleSelectionne() {
      // Vérifications
      if (!this.articleSelectionne) {
        this.errorMessage = "Veuillez sélectionner un article";
        return;
      }
      
      if (!this.quantiteArticle || this.quantiteArticle <= 0) {
        this.errorMessage = "La quantité doit être supérieure à 0";
        return;
      }

      const nouvelleQuantite = parseInt(this.quantiteArticle);
      const codeArticle = this.articleSelectionne.coarti;

      // Vérifier si l'article était supprimé
      const articleEtaitSupprime = this.articlesSupprimes.includes(codeArticle);
      
      // Si l'article était supprimé, le retirer de la liste des supprimés
      if (articleEtaitSupprime) {
        const indexSupprime = this.articlesSupprimes.indexOf(codeArticle);
        this.articlesSupprimes.splice(indexSupprime, 1);
      }

      // Vérifier si l'article existe déjà dans les articles ajoutés
      const articleExisteIndex = this.articlesAjoutes.findIndex(art => art.code === codeArticle);
      if (articleExisteIndex !== -1) {
        // L'article existe déjà, additionner les quantités
        this.articlesAjoutes[articleExisteIndex].quantite += nouvelleQuantite;
        
        // Réinitialiser la sélection
        this.annulerSelection();

        this.errorMessage = '';
        this.confirmationMessage = `Quantité ajoutée à l'article existant (nouvelle quantité: ${this.articlesAjoutes[articleExisteIndex].quantite})`;
        
        // Sauvegarder automatiquement
        
        setTimeout(() => {
          this.confirmationMessage = '';
        }, 3000);
        return;
      }

      // Vérifier si l'article existe dans les articles existants (non supprimés)
      const articleExistantExiste = this.articles.find(art => art.npce === codeArticle);
      if (articleExistantExiste && !this.articlesSupprimes.includes(articleExistantExiste.npce)) {
        // L'article existe dans l'affaire originale
        // S'assurer que l'entrée existe dans articlesModifications
        if (!this.articlesModifications[codeArticle]) {
          this.articlesModifications[codeArticle] = {
            nouvelleQuantite: ''
          };
        }

        const quantiteOriginale = parseInt(articleExistantExiste.qte) || 0;
        let quantiteActuelle = quantiteOriginale;
        
        // Si l'article était supprimé, remettre la quantité à zéro
        if (articleEtaitSupprime) {
          quantiteActuelle = 0;
        } else {
          // Si une nouvelle quantité a déjà été saisie, l'utiliser comme base
          if (this.articlesModifications[codeArticle].nouvelleQuantite !== '') {
            quantiteActuelle = parseInt(this.articlesModifications[codeArticle].nouvelleQuantite) || quantiteOriginale;
          }
        }
        
        const nouvelleQuantiteTotale = quantiteActuelle + nouvelleQuantite;

        // Mettre à jour la quantité modifiée
        this.articlesModifications[codeArticle].nouvelleQuantite = nouvelleQuantiteTotale;

        // Réinitialiser la sélection
        this.annulerSelection();

        this.errorMessage = '';
        this.confirmationMessage = `Quantité ${articleEtaitSupprime ? 'remise à zéro puis ajoutée' : 'ajoutée'} à l'article existant (nouvelle quantité: ${nouvelleQuantiteTotale})`;
        
        
        setTimeout(() => {
          this.confirmationMessage = '';
        }, 3000);
        return;
      }

      // Si l'article n'existe nulle part, l'ajouter comme nouvel article
      this.articlesAjoutes.push({
        code: this.articleSelectionne.coarti,
        designation1: this.articleSelectionne.desa1 || '',
        designation2: this.articleSelectionne.desa2 || '',
        designation3: this.articleSelectionne.desa3 || '',
        quantite: nouvelleQuantite
      });

      // Réinitialiser la sélection
      this.annulerSelection();

      this.errorMessage = '';
      this.confirmationMessage = "Article ajouté avec succès";
            
      setTimeout(() => {
        this.confirmationMessage = '';
      }, 3000);
    },

    ajouterArticleManuel() {
      const code = String(this.nouveauArticleCode || '').trim();
      const designation = String(this.nouveauArticleDesignation || '').trim();
      const quantite = parseInt(this.nouveauArticleQuantite, 10);

      if (!code || !designation) {
        this.errorMessage = "Merci de renseigner le code article et sa désignation";
        return;
      }

      if (!quantite || quantite <= 0) {
        this.errorMessage = "La quantité doit être supérieure à 0";
        return;
      }

      const codeNormalise = code.toUpperCase();
      const existeDansArticles = this.articles.some(art => String(art.npce || art.coarti || '').trim().toUpperCase() === codeNormalise);
      const existeDansAjoutes = this.articlesAjoutes.some(art => String(art.code || '').trim().toUpperCase() === codeNormalise);

      if (existeDansArticles || existeDansAjoutes) {
        this.errorMessage = "Cet article est déjà présent dans la liste";
        return;
      }

      this.articlesAjoutes.push({
        code: codeNormalise,
        designation1: designation,
        designation2: '',
        designation3: '',
        quantite
      });

      this.errorMessage = '';
      this.confirmationMessage = "Article ajouté manuellement";
      this.resetNouvelArticle();

      setTimeout(() => {
        this.confirmationMessage = '';
      }, 3000);
    },

    resetNouvelArticle() {
      this.nouveauArticleCode = '';
      this.nouveauArticleDesignation = '';
      this.nouveauArticleQuantite = '';
    },

    supprimerArticle(index, type) {
      if (confirm("Êtes-vous sûr de vouloir supprimer cet article ?")) {
        const codeArticle = this.tousLesArticles[index].code;
        
        if (type === 'existant') {
          // Pour un article existant, l'ajouter à la liste des articles supprimés
          if (!this.articlesSupprimes.includes(codeArticle)) {
            this.articlesSupprimes.push(codeArticle);
          }
        } else {
          // Pour un article ajouté, le supprimer directement de la liste
          const articlesAjoutesIndex = this.articlesAjoutes.findIndex(art => art.code === codeArticle);
          if (articlesAjoutesIndex !== -1) {
            this.articlesAjoutes.splice(articlesAjoutesIndex, 1);
          }
        }
        
        // Sauvegarder automatiquement après suppression
      }
    },

    envoyerDemande() {
      if (this.destinataires.length === 0) {
        this.errorMessage = "Veuillez sélectionner au moins un destinataire";
        return;
      }

      const demande = {
        affaireOrigine: this.selectedAffaire ? this.selectedAffaire.naf : '',
        nouvelleDescription: this.nouvelleDescription,
        modeCreation: this.modeCreation,
        evolution: this.evolution,
        articlesFusionnes: this.articlesFusionnes,
        destinataires: this.destinataires,
        demandeur: this.loggedInEmail,
        demandeurNom: this.utilisateur,
        dateDemande: new Date().toISOString(),
        typeAction: "envoyer"
      };

      const formData = new FormData();
      formData.append('demande', JSON.stringify(demande));
      this.photosSelectionnees.forEach((file, index) => {
        formData.append(`photos[${index}]`, file);
      });

      axios.post('https://www.simef.fr/espace-client/api/evolutionAffaire.php', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      })
        .then(() => {
          this.confirmationMessage = "Demande envoyée ✅";
          this.resetForm();
        })
        .catch(() => {
          this.errorMessage = "Erreur lors de l'envoi de la demande";
        });
    },

    sauvegarder() {
      const brouillon = {
        affaireOrigine: this.selectedAffaire ? this.selectedAffaire.naf : '',
        nouvelleDescription: this.nouvelleDescription,
        modeCreation: this.modeCreation,
        evolution: this.evolution,
        articlesFusionnes: this.articlesFusionnes,
        destinataires: this.destinataires,
        demandeur: this.loggedInEmail,
        demandeurNom: this.utilisateur,
        dateDemande: new Date().toISOString(),
        typeAction: "brouillon"
      };

      const formData = new FormData();
      formData.append('demande', JSON.stringify(brouillon));
      this.photosSelectionnees.forEach((file, index) => {
        formData.append(`photos[${index}]`, file);
      });

      axios.post('https://www.simef.fr/espace-client/api/evolutionAffaire.php', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      })
      .then(response => {
        this.confirmationMessage = "Brouillon sauvegardé ✅";
        this.errorMessage = '';

        // 🟢 Mise à jour directe de la liste :
        if (this.listeRef && typeof this.listeRef.ajouterBrouillon === 'function') {
          this.listeRef.ajouterBrouillon({
            id: response.data.id, // ← id renvoyé par ton PHP
            nouvelle_description: this.nouvelleDescription,
            date_demande: new Date().toISOString(),
            demandeur: this.demandeur,
            statut: 'brouillon'
          });
        }

        setTimeout(() => {
          this.confirmationMessage = '';
        }, 2000);
      })
      .catch(() => {
        this.errorMessage = "Erreur lors de l'enregistrement du brouillon";
      });
    },



    resetEvolution() {
      this.evolution = {
        piece: '',
        designation: '',
        client: '',
        quantite: '',
        delai: '',
        observations: ''
      };
    },

    resetForm() {
      this.selectedAffaire = null;
      this.nouvelleDescription = '';
      this.modeCreation = 'copier';
      this.destinataires = [];
      this.articles = [];
      this.articlesSupprimes = [];
      this.articleDetails = {};
      this.articlesModifications = {};
      this.articlesAjoutes = [];
      this.searchArticle = '';
      this.articlesDisponibles = [];
      this.articleSelectionne = null;
      this.quantiteArticle = '';
      this.resetEvolution();
      this.resetNouvelArticle();
      this.isBrouillon = false;
      this.photosSelectionnees = [];
      if (this.$refs.photosInput) {
        this.$refs.photosInput.value = '';
      }
    },
    remplirDepuisBrouillon(data) {
      const e = data.evolution;

      this.modeCreation = e.mode_creation;
      this.nouvelleDescription = e.nouvelle_description;
      this.evolution.observations = e.observations || '';
      this.demandeur = e.demandeur;
      this.dateDemande = e.date_demande;
      this.destinataires = e.destinataires ? e.destinataires.split(',') : [];

      // --- Indicateur : on est en train de charger un brouillon
      this.isLoadingBrouillon = true;

      // 🧩 Cas 1 : "Repartir de zéro" → pas d’affaire à chercher
      if (
        this.modeCreation === 'zero' ||
        this.modeCreation === 'Repartir de zéro' ||
        this.modeCreation?.toLowerCase?.() === 'zero'
      ) {
        console.log('⚙️ Mode zéro détecté → on utilise directement les articles du brouillon');
        this.selectedAffaire = null;
        this.articles = [];
        this.appliquerArticlesDepuisBrouillon(data.articles);
        this.isLoadingBrouillon = false;
        return; // ✅ on sort ici, pas de recherche d’affaire
      }

      // 🧩 Cas 2 : autre mode → comportement habituel
      const setAffaire = () => {
        const affaireTrouvee = this.affaires.find(a => a.naf === e.affaire_existante);

        if (affaireTrouvee) {
          this.selectedAffaire = affaireTrouvee;

          if (this.modeCreation === 'copier') {
            this.chargerArticlesAffaire()
              .then(() => {
                this.appliquerArticlesDepuisBrouillon(data.articles);
                this.isLoadingBrouillon = false;
              })
              .catch(err => {
                console.error("❌ Erreur chargement articles :", err);
                this.isLoadingBrouillon = false;
              });
          } else {
            this.appliquerArticlesDepuisBrouillon(data.articles);
            this.isLoadingBrouillon = false;
          }
        } else {
          console.warn(`⚠️ Affaire ${e.affaire_existante} introuvable dans la liste.`);
          this.isLoadingBrouillon = false;
        }
      };

      if (this.affaires?.length) setAffaire();
      else {
        const checkAffaires = setInterval(() => {
          if (this.affaires?.length) {
            clearInterval(checkAffaires);
            setAffaire();
          }
        }, 200);
      }
    },
    demarrerNouvelleEvolution() {
      console.log('🆕 Démarrage d’une nouvelle évolution');
      
      // On remet le formulaire à zéro
      this.isBrouillon = false;
      this.isLoadingBrouillon = false;
      this.modeCreation = 'copier';
      this.nouvelleDescription = '';
      this.demandeur = this.loggedInEmail || '';
      this.dateDemande = new Date().toISOString().split('T')[0];
      this.destinataires = [];
      this.selectedAffaire = null;
      this.articles = [];
      this.articlesAjoutes = [];
      this.articlesSupprimes = [];
      this.articlesModifications = {};
      this.resetPhotosSelection();

      // Recharge les affaires disponibles
      if (typeof this.getAffairesUtilisateur === 'function') {
        this.getAffairesUtilisateur();
      }

      console.log('✅ Formulaire réinitialisé.');
    },
    handlePhotosChange(event) {
      const fichiers = Array.from(event.target?.files || []);
      if (!fichiers.length) return;
      this.photosSelectionnees = [...this.photosSelectionnees, ...fichiers];
      if (event.target) {
        event.target.value = '';
      }
    },
    supprimerPhoto(index) {
      if (index < 0 || index >= this.photosSelectionnees.length) return;
      this.photosSelectionnees.splice(index, 1);
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  $primary: #2b358d;
  $success: #28a745;
  $danger: #dc3545;
  $grey-bg: #f7f7f7;
  $border: #d4d4d4;


  h2 {
    text-align: left;
    font-size: 2rem;
    margin-bottom: 24px;
    
  }
  .fichiers {
    margin-bottom: 28px;
    .form-label {
      font-weight: 600;
      margin-bottom: 8px;
      display: block;
      color: #222;
    }
    input, select, textarea {
      width: 100%;
      border: 1px solid $border;
      border-radius: 0;
      padding: 12px 16px;
      font-size: 1rem;
      margin-bottom: 8px;
      background: $grey-bg;
      transition: border 0.2s, box-shadow 0.2s;
      &:focus {
        border-color: $primary;
        box-shadow: 0 0 0 2px rgba(35,70,173,0.08);
        outline: none;
      }
    }
    label {
      font-weight: 500;
      margin-bottom: 6px;
      display: block;
    }
  }
  .affaire-select {
    width: 100%;
    border: 1px solid #d4d4d4;
    padding: 10px;
    line-height: initial;
    margin-bottom: 10px;
  }
  .radio-group, .checkbox-group {
    display: flex;
    flex-wrap: wrap;
    gap: 5px;
    margin-top: 8px;
    align-items: center;
  }
  .radio-option, .checkbox-option {
    display: flex!important;
    align-items: center;
    gap: 5px;
    width: 49%;
    background: #f7f7f7;
    border-radius: 0;
    font-weight: 500;
    cursor: pointer;
    input {
      accent-color: $primary;
      width: initial!important;
      margin: 0 !important;
    }
    &:hover {
      background: #e6eaf3;
    }
  }
  textarea {
    width: 100%;
    border: 1px solid #d4d4d4;
    padding: 10px;
    line-height: initial;
    margin-bottom: 10px;
    min-height: 80px;
    resize: vertical;
  }
  .actions {
    display: flex;
    gap: 14px;
    flex-wrap: wrap;
    margin-top: 10px;
    button {
      border: none;
      border-radius: 0;
      padding: 12px 28px;
      font-weight: 600;
      font-size: 1rem;
      cursor: pointer;
      transition: background 0.2s, box-shadow 0.2s;
      display: flex;
      align-items: center;
      gap: 8px;
      &.btn-primary {
        background: $primary;
        color: #fff;
        &:hover { background: darken($primary, 8%); }
        &:disabled { background: #bfc8e6; cursor: not-allowed; }
      }
      &.btn-secondary {
        background: #6c757d;
        color: #fff;
        &:hover { background: #565e64; }
      }
      svg {
        width: 18px;
        height: 18px;
      }
    }
  }
  .input-hint {
    font-size: 0.9rem;
    color: #666;
    margin: 4px 0 0;
  }
  .photos-list {
    list-style: none;
    padding: 0;
    margin: 12px 0 0;
    .photo-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 8px 0;
      border-bottom: 1px solid #e3e3e3;
      &:last-child {
        border-bottom: none;
      }
      .photo-infos {
        display: flex;
        flex-direction: column;
        strong {
          font-size: 0.95rem;
          color: #222;
        }
        small {
          color: #555;
        }
      }
    }
  }
  .btn-link {
    background: none;
    border: none;
    color: $primary;
    font-weight: 600;
    cursor: pointer;
    padding: 0;
    &:hover {
      text-decoration: underline;
    }
  }
  .file-input {
    background: $grey-bg;
    border: 1px solid $border;
    padding: 10px;
    width: 100%;
    font-size: 1rem;
    cursor: pointer;
    &::-webkit-file-upload-button {
      background: $primary;
      color: #fff;
      border: none;
      padding: 8px 14px;
      margin-right: 12px;
      cursor: pointer;
      font-weight: 600;
    }
    &:hover::-webkit-file-upload-button {
      background: darken($primary, 8%);
    }
  }
  .alert {
    padding: 14px 18px;
    margin: 18px 0 0 0;
    border-radius: 0;
    font-size: 1rem;
    font-weight: 500;
    animation: fadeIn 0.4s;
    &.alert-success {
      background-color: #e6f9e7;
      color: $success;
      border: 1px solid #b7e7c2;
    }
    &.alert-error {
      background-color: #fdeaea;
      color: $danger;
      border: 1px solid #f5c6cb;
    }
  }
  @keyframes fadeIn {
    from { opacity: 0; transform: translateY(10px); }
    to { opacity: 1; transform: none; }
  }
  h3 {
    color: $primary;
    margin: 18px 0 12px 0;
    font-size: 1.15rem;
    font-weight: 700;
  }
  .articles-container {
    max-height: 400px;
    overflow-y: auto;
    border: 1px solid $border;
    border-radius: 0;
    margin-bottom: 18px;
    background: $grey-bg;
    box-shadow: 0 1px 4px rgba(43,53,141,0.04);
  }
  table.articlesListe {
    width: 100%;
    font-size: 0.97rem;
    border-collapse: separate;
    border-spacing: 0;
    thead {
      background: $primary;
      color: #fff;
      position: sticky;
      top: 0px;
      th {
        padding: 10px 8px;
        font-size: 0.95rem;
        font-weight: 600;
        color: #fff;
        border-top-left-radius: 0;
        border-top-right-radius: 0;
      }
    }
    tbody {
      tr {
        transition: background 0.15s;
        &:hover { background: #e6eaf3; }
      }
      td {
        padding: 10px 8px;
        font-size: 0.97rem;
        font-weight: 500;
      }
    }
    .ligne-claire {
      background-color: #f9f9fb;
    }
    .ligne-foncee {
      background-color: #ebebeb;
    }
  }
  .qte-input {
    width: 90px !important;
    padding: 7px !important;
    font-size: 0.97rem;
    border-radius: 0;
  }
  .obs-input {
    width: 90% !important;
    min-height: 40px !important;
    padding: 7px !important;
    font-size: 0.97rem;
    border-radius: 0;
    resize: vertical;
  }
  .ajout-article {
    background: #f9f9f9;
    border: 1px solid #e0e0e0;
    padding: 22px;
    margin-bottom: 18px;
    border-radius: 8px;
    .form-row {
      display: flex;
      gap: 18px;
      margin-bottom: 12px;
      flex-wrap: wrap;
      .form-group {
        flex: 1;
        min-width: 220px;
        label {
          display: block;
          margin-bottom: 6px;
          font-weight: 600;
        }
        input {
          width: 100%;
          padding: 10px;
          border: 1px solid $border;
          border-radius: 6px;
          font-size: 1rem;
        }
      }
    }
    .btn-add {
      background: $success;
      color: white;
      border: none;
      border-radius: 8px;
      padding: 10px 22px;
      cursor: pointer;
      display: flex;
      align-items: center;
      gap: 8px;
      font-weight: 600;
      font-size: 1rem;
      svg {
        width: 18px;
        height: 18px;
      }
      &:hover {
        background: darken($success, 8%);
      }
    }
  }
  .btn-delete {
    background: $danger;
    color: white;
    border: none;
    border-radius: 0px;
    padding: 7px 14px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1rem;
    margin: 0px!important;
    svg {
      width: 16px;
      height: 16px;
      margin: 0px!important;
    }
    &:hover {
      background: darken($danger, 8%);
    }
  }
  .badge {
    padding: 4px 10px;
    border-radius: 12px;
    font-size: 0.85rem;
    font-weight: 700;
    display: inline-block;
    &.badge-primary {
      background: $primary;
      color: white;
    }
    &.badge-success {
      background: $success;
      color: white;
    }
    &.badge-danger {
      background: $danger;
      color: white;
    }
    &.badge-modifie {
      background: #ffa600;
      color: #fff;
    }
    &.badge-ignored {
      background: #bfc8e6;
      color: #2b358d;
    }
  }
  .search-article {
    width: 100%;
    .search-container {
      position: relative;
      width: 100%;
    }
    .search-input {
      width: 100%;
      padding: 12px;
      border: 1px solid $border;
      border-radius: 8px;
      font-size: 1rem;
      background: $grey-bg;
      &:focus {
        border-color: $primary;
        outline: none;
      }
    }
    .articles-dropdown {
      position: absolute;
      top: 100%;
      left: 0;
      right: 0;
      background: white;
      border: 1px solid $border;
      border-top: none;
      max-height: 220px;
      overflow-y: auto;
      z-index: 1000;
      border-radius: 0;
      .article-option {
        padding: 12px;
        cursor: pointer;
        border-bottom: 1px solid #f0f0f0;
        &:hover {
          background-color: #e6eaf3;
        }
        .article-code {
          font-weight: 700;
          color: $primary;
          font-size: 1rem;
        }
        .article-designations {
          font-size: 0.92rem;
          color: #666;
          margin-top: 4px;
        }
      }
    }
  }
  .nouvel-article-form {
    margin-top: 20px;
    padding: 16px;
    border: 1px dashed $border;
    border-radius: 8px;
    background: #f8f9ff;
    h4 {
      margin-bottom: 12px;
      color: $primary;
      font-size: 1rem;
    }
    .form-row {
      gap: 16px;
      .form-group {
        flex: 1;
      }
    }
    .btn-add {
      margin-top: 12px;
    }
  }
  .article-selectionne {
    margin-top: 18px;
    padding: 18px;
    background: #f0f8ff;
    border: 1px solid #b3d9ff;
    border-radius: 8px;
    h4 {
      color: $primary;
      margin-bottom: 12px;
      font-size: 1.1rem;
      font-weight: 700;
    }
    .readonly-input {
      background-color: #f8f9fa !important;
      color: #666 !important;
      cursor: not-allowed;
      border-radius: 6px;
    }
    .btn-cancel {
      background: #6c757d;
      color: white;
      border: none;
      border-radius: 8px;
      padding: 10px 22px;
      cursor: pointer;
      display: flex;
      align-items: center;
      gap: 8px;
      margin-left: 10px;
      font-weight: 600;
      font-size: 1rem;
      svg {
        width: 18px;
        height: 18px;
      }
      &:hover {
        background: #5a6268;
      }
    }
  }
  .article-details {
    margin-bottom: 18px;
    .form-row {
      display: flex;
      gap: 14px;
      margin-bottom: 10px;
      flex-wrap: wrap;
      .form-group {
        flex: 1;
        min-width: 200px;
        label {
          display: block;
          margin-bottom: 5px;
          font-weight: 600;
        }
        input {
          width: 100%;
          padding: 8px;
          border: 1px solid $border;
          border-radius: 6px;
          font-size: 1rem;
        }
      }
    }
  }
  input[type=file] {
    position: inherit;
    opacity: 1;
    height: auto;
    width: 100% !important;
  }
  button.btn-link {
    color: #fff !important;
    text-decoration: auto;
    &:hover {
      text-decoration: none;
    }
  }
</style>
